'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../common/styles');

exports.default = {
	fixedLabelColor: {
		color: _styles.colors.baseColors.charcoalGrey
	},
	fixedAsterixColor: {
		color: _styles.colors.baseColors.orange
	},
	asterisk: function asterisk(valid) {
		return {
			color: valid === false ? _styles.colors.baseColors.red : _styles.colors.baseColors.orange
		};
	}
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMRequiredLabel/styles/index.js